const jobRouter = [
	// 推荐职位
	{
		path: '/jobs/recommend',
		name: 'recommend-jobs',
		component: () => import('../views/job-list/recommend')
	},
	// 职位聚合
	{
		path: '/jobs/aggregation/collect',
		name: 'jobs-aggregation-collect',
		component: () => import('../views/job-list/aggregation')
	},
	{
		path: '/jobs/aggregation/new',
		name: 'jobs-aggregation-new',
		component: () => import('../views/job-list/aggregation')
	},
	{
		path: '/jobs/aggregation/publish',
		name: 'jobs-aggregation-publish',
		component: () => import('../views/job-list/aggregation')
	},
	{
		path: '/jobs/aggregation/interview',
		name: 'jobs-aggregation-interview',
		component: () => import('../views/job-list/aggregation')
	},
	// 校招网申列表 old
	{
		path: '/jobs/campus',
		name: 'campus-jobs',
		component: () => import('../views/job-list/campus'),
		meta: {
			diffShare: true
		}
	},
	// 校招网申列表 new
	{
		path: '/jobs/campus/offers',
		name: 'campus-offers',
		component: () => import('../views/job-campus-offer/pages/list'),
		meta: {
			diffShare: true
		}
	},
	// 校招网申列表 new
	{
		path: '/jobs/campus/manage',
		name: 'campus-manage',
		component: () => import('../views/job-campus-offer/pages/manage')
	},
	// 校招收藏
	{
		path: '/jobs/campus/collect',
		name: 'campus-collect',
		component: () => import('../views/job-campus-offer/pages/collect'),
	},
	// 待办创建
	{
		path: '/jobs/campus/thing/create',
		name: 'campus-thing-create',
		component: () => import('../views/job-campus-offer/pages/create'),
	},
	// 校招详情 new
	{
		path: '/jobs/campus/offers/:token',
		name: 'campus-offers-detail',
		component: () => import('../views/job-campus-offer/pages/detail'),
		meta: {
			diffShare: true
		}
	},
	{
		path: '/jobs/recommend-jd',
		name: 'recommend-jobs-jd',
		component: () => import('../views/job-list/recommend-jd')
	},
	{
		path: '/jobs/recommend-jd-card',
		name: 'recommend-jobs-jd-card',
		component: () => import('../views/job-list/recommend-jd-card')
	},
	{
		path: '/jobs/recommend-jd-card/finish',
		name: 'jd-card-finish',
		component: () => import('../views/job-list/recommend-jd-card-finish')
	},
	{
		path: '/jobs/campus/search',
		name: 'campus-search',
		component: () => import('../views/job-search/campus')
	},
	{
		path: '/jobs/campus/remind',
		name: 'campus-remind',
		component: () => import('../views/job-function/campus-remind')
	},
	{
		path: '/jobs/recommend/search',
		name: 'recommend-search',
		component: () => import('../views/job-search/recommend')
	},
  {
		path: '/jobs/company_job/:token',
		name: 'companyjob-search',
		component: () => import('../views/job-search/companyJob')
	},
	{
		path: '/jobs/campus/:token',
		name: 'campus-detail',
		component: () => import('../views/job-detail/campus'),
		meta: {
			diffShare: true
		}
	},
	{
		path: '/jobs/recommend/:token',
		name: 'recommend-detail',
		component: () => import('../views/job-detail/recommend'),
		meta: {
			diffShare: true
		}
	},
	{
		path: '/jobs/recommendation/detail/:token',
		name: 'recommendation-detail',
		component: () => import('../views/job-detail/recommendation')
	},
	{
		path: '/jobs/mailing',
		name: 'jobs-mailing',
		component: () => import('../views/job-function/mailing'),
		meta: {
			isLogin: true
		}
	},
  {
		path: '/jobs/inbox',
		name: 'jobs-inbox',
		component: () => import('../views/job-function/inbox'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/jobs/setting',
		name: 'jobs-setting',
		component: () => import('../views/job-function/setting'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/jobs/mailing/practice',
		name: 'mailing-practice',
		component: () => import('../views/job-function/mailing-practice'),
		meta: {
			isLogin: true
		}
	},
	{
		path: '/welcome/to_app',
		name: 'welcome-to-app',
		component: () => import('../views/job-detail/welcome_to_app'),
		meta: {
			isLogin: false
		}
	},
	{
		path: '/wondercv_app/open_app',
		name: 'open-app',
		component: () => import('../views/job-detail/open_app'),
		meta: {
			isLogin: false
		}
	},
	{
		path: '/activity/:url',
		name: 'springOffer',
		component: () => import('@/views/job-spring-offer/springOffer')
	},
	{
		path: '/job/share',
		name: 'job-share',
		component: () => import('@/views/job-detail/job-share')
	}
]

export default jobRouter
